import { reducer, initialStateBase } from './newCollection';

const initialState = Object.assign({}, initialStateBase);

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return reducer(state, action, 'LAYOUT');
    }
};
